export default __webpack_public_path__ + "16a839d2abfa318c2e69c7a7af17f6c2.ttf";